import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import DataTable, { Alignment } from "react-data-table-component";
import FilterComponent from "./FilterComponent";
import Spinner from "../components/layout/Spinner";
import { PERMISSIONS } from "../Permission/Permission";
import { getAllChannelList, dealerList } from "../store/dealer/actions";
import { GetUnusedDealers } from "../store/DealerActivationCount/actions";
import BulkUploadTMobilePassword from "../components/BulkUploadTMobilePassword";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";

function DealerActivationCount(props) {
  const dispatch = useDispatch();
  const [RoleID, setRoleID] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [dataSearch, setDataSearch] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [LoginId, setLoginID] = useState("");
  const [popUp, setpopUp] = useState(false);
  const [popUpDeleteContent, setPopUpDeleteContent] = useState("");
  const [allowExport, setAllowExport] = useState(false);
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const [searchDealer, setSearchDealer] = useState({
    companyID: "",
    channelId: 0,
  });
  useEffect(() => {
    const loginId = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).ID
      : null;

    const companyId = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).CompanyID
      : null;

    const roleId = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).RoleID
      : null;

    setRoleID(roleId);
    setLoginID(loginId);

    setSearchDealer((prevState) => ({
      ...prevState,
      companyID: companyId,
    }));
  }, []);

  var filterArray = [];
  for (const [key, value] of Object.entries(PERMISSIONS)) {
    if (key == RoleID) {
      filterArray.push(value);
    }
  }

  const columns = [
    {
      name: "#",
      width: "30px",
      selector: (row) => row.serial,
    },
    {
      name: "ACode",
      selector: (row) => row.ACode,
    },
    {
      name: "DEALER NAME",
      selector: (row) => row.dealerName,
    },

    {
      name: "CHANNEL",
      selector: (row) => row.ChannelName,
    },

    {
      name: "HOURLY LIMIT",
      selector: (row) => row.hourlyLimit,
    },
    {
      name: "DAILY LIMIT",
      selector: (row) => row.dailyLimit,
    },
    {
      name: "HOURLY COUNT",
      selector: (row) => row.hourlyCount,
    },
    {
      name: "DAILY COUNT",
      selector: (row) => row.dailyCount,
    },
    {
      name: "MONTHLY COUNT",
      selector: (row) => row.monthlyCount,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "50px",
      },
    },
    headCells: {
      style: {
        justifyContent: "center",
        textAlign: "center",
        paddingLeft: "8px",
        paddingRight: "0px",
        fontWeight: "bold",
        fontSize: "13px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "0px",
        justifyContent: "center",
        textAlign: "center",
      },
    },
  };

  const filteredItems =
    props.getUnusedDealersData &&
    props.getUnusedDealersData.filter((item) =>
      JSON.stringify(item).toLowerCase().includes(filterText.toLowerCase()),
    );

  const filterData =
    filteredItems &&
    filteredItems.map((data, key) => ({
      serial: <p>{key + 1}</p>,
      dealerName: (
        <p style={{ whiteSpace: "break-spaces" }}>{data.DealerName}</p>
      ),
      ACode: <p>{data.ACode == null || data.ACode === "" ? "" : data.ACode}</p>,
      ChannelName: <p>{data.ChannelName}</p>,

      hourlyLimit: <p>{data.HourlyLimit}</p>,

      dailyLimit: <p>{data.DailyLimit}</p>,

      hourlyCount: <p>{data.HourlyCount}</p>,

      dailyCount: <p>{data.DailyCount}</p>,

      monthlyCount: <p>{data.MonthlyCount}</p>,
    }));

  const handleDealerChange = (e) => {
    const fname = e.target.name;
    const fvalue = e.target.value;
    setSearchDealer((prevState) => ({
      ...prevState,
      [fname]: fvalue,
    }));
  };

  const handleSearchData = (e) => {
    e.preventDefault();

    setDataSearch(true);

    dispatch(
      GetUnusedDealers({
        companyID: searchDealer.companyID,
        channelID: searchDealer.channelId,
      }),
    );

    setAllowExport(true);
  };

  const handleClear = () => {
    if (filterText) {
      setFilterText("");
    }
  };

  if (props.updateError === "Invalid token") {
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");
    window.location.href = "/";
  }

  const listData =
    props.getUnusedDealersData &&
    props.getUnusedDealersData.map((data, key) => ({
      SNo: key + 1,
      // DealerID: data.ID,
      ACode: data.ACode,
      DealerName: data.DealerName,
      ChannelName: data.ChannelName,
      HourlyLimit: data.HourlyLimit,
      DailyLimit: data.DailyLimit,
      HourlyCount: data.HourlyCount,
      DailyCount: data.DailyCount,
      MonthlyCount: data.MonthlyCount,
    }));

  const exportToCSV = async () => {
    if (listData.length > 0) {
      const ws = XLSX.utils.json_to_sheet(listData);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      await FileSaver.saveAs(data, "Dealer Activation Count" + fileExtension);
    }
  };

  return (
    <>
      {
        <div className="nk-block-head-content">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h className="nk-block-title page-title">Dealer Activation Count</h>
          </div>
          <div className="card p-2" style={{ marginTop: "12px" }}>
            <div className="card-inner p-0">
              <div className="nk-block">
                <form method="post" onSubmit={handleSearchData}>
                  <div className="row g-3 align-items-end">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label className="form-label" htmlFor="dealerID">
                          Channel
                        </label>
                        <div className="form-control-wrap">
                          <select
                            name="channelId"
                            className="form-control"
                            id="channelId"
                            value={searchDealer.channelId}
                            onChange={(e) => handleDealerChange(e)}
                          >
                            <option value="0" name="all">
                              All
                            </option>
                            {props.channelData &&
                              props.channelData.map((channel) => (
                                <option key={channel.ID} value={channel.ID}>
                                  {channel.ChannelName}
                                </option>
                              ))}

                            <option value="1" name="enk">
                              ENK
                            </option>
                            {props.channelData &&
                              props.channelData.map((channel) => (
                                <option key={channel.ID} value={channel.ID}>
                                  {channel.ChannelName}
                                </option>
                              ))}

                            <option value="157" name="bnk">
                              BNK
                            </option>
                            {props.channelData &&
                              props.channelData.map((channel) => (
                                <option key={channel.ID} value={channel.ID}>
                                  {channel.ChannelName}
                                </option>
                              ))}

                            <option value="213" name="global">
                              GLOBAL
                            </option>
                            {props.channelData &&
                              props.channelData.map((channel) => (
                                <option key={channel.ID} value={channel.ID}>
                                  {channel.ChannelName}
                                </option>
                              ))}

                            <option value="267" name="gsw">
                              GSW
                            </option>
                            {props.channelData &&
                              props.channelData.map((channel) => (
                                <option key={channel.ID} value={channel.ID}>
                                  {channel.ChannelName}
                                </option>
                              ))}

                            <option value="345" name="eaha">
                              EAHA
                            </option>
                            {props.channelData &&
                              props.channelData.map((channel) => (
                                <option key={channel.ID} value={channel.ID}>
                                  {channel.ChannelName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <button
                        type="submit"
                        disabled={props.loading}
                        className="btn btn-primary"
                        style={{ marginTop: "1.9rem" }}
                      >
                        {props.loading === true && (
                          <span
                            className="spinner-border spinner-border-sm"
                            aria-hidden="true"
                          ></span>
                        )}
                        <span>Search</span>{" "}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {dataSearch ? (
            <div className="card p-2">
              <div className="card-inner p-0">
                <div className=" d-flex justify-content-between">
                  <FilterComponent
                    onFilter={(e) => setFilterText(e.target.value)}
                    onClear={handleClear}
                    filterText={filterText}
                  />
                  {dataSearch ? (
                    <div className="col text-end">
                      <Link
                        to="#"
                        className="btn btn-success me-2"
                        onClick={() => allowExport && exportToCSV()}
                      >
                        <em className="icon ni ni-download"></em>
                        <span
                          style={{
                            marginTop: "4px",
                            paddingLeft: "0px",
                            fontSize: "14px",
                            height:"20px",
                          }}
                        >
                          Export
                        </span>
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <DataTable
                  progressPending={props.getUnusedDealerLoading}
                  progressComponent={<Spinner />}
                  columns={columns}
                  data={filterData}
                  customStyles={customStyles}
                  striped
                  responsive
                  pagination
                />
              </div>
            </div>
          ) : (
            ""
          )}
          {dataSearch ? (
            <div className="col-sm-12 text-end">
              {/* <button type='submit' className="btn btn-primary" disabled={props.updateloading} style={{ 'marginTop': '1.9rem' }} onClick={handleUpdate}>
                    {props.updateloading === true && <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>}
                    <span>Update</span> </button> */}
            </div>
          ) : (
            ""
          )}
        </div>
      }
    </>
  );
}
const mapStateToProps = (state) => {
  const { channelData, dealerData, apiError, message, loading, modalMessage } =
    state.dealer;
  const {
    updatemessage,
    updateError,
    updateloading,
    bulkUpdatemessage,
    pageNumberChnage,
  } = state.addDealerCredentials;
  const { getUnusedDealersData, getUnusedDealerLoading } =
    state.DealerActivationCount;
  return {
    channelData,
    dealerData,
    apiError,
    message,
    loading,
    modalMessage,
    updatemessage,
    updateError,
    updateloading,
    bulkUpdatemessage,
    pageNumberChnage,
    getUnusedDealerLoading,
    getUnusedDealersData,
  };
};

export default withRouter(
  connect(mapStateToProps, { dealerList, GetUnusedDealers })(
    DealerActivationCount,
  ),
);
